const pageSpeedInsightLogo = ({ width = 75, height = 75 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1359_2114)">
        <path
          d="M46.5896 3.40834H3.40625C1.525 3.40834 0 4.93751 0.00208333 6.81876L0 43.1813V43.1875C0 45.0688 1.52708 46.5917 3.40625 46.5917H46.5937C48.4771 46.5917 50 45.0625 50 43.1813V6.81876C50.0333 4.96459 48.4167 3.40209 46.5896 3.40834ZM8.28958 6.01251C9.31458 4.95626 10.9542 6.59584 9.89375 7.62084C8.87083 8.67918 7.23125 7.03959 8.28958 6.01459V6.01251ZM3.75 6.02084C4.80625 4.96043 6.41667 6.57293 5.35833 7.62709C4.33125 8.67293 2.70417 7.04376 3.75 6.02084ZM48.9583 43.1833C48.9833 44.4563 47.8667 45.575 46.5896 45.55H3.40625C2.77874 45.5489 2.17731 45.2989 1.73398 44.8547C1.29066 44.4106 1.04167 43.8088 1.04167 43.1813L1.04375 10.2292H48.9583V43.1833ZM22.9167 33.6646L35.3042 24.1292C35.7937 23.7125 36.5042 24.3979 36.1146 24.9042L36.1104 24.9L27.9104 38.1292C27.655 38.5481 27.3123 38.907 26.9056 39.1815C26.4989 39.4559 26.0378 39.6394 25.5537 39.7195C25.0697 39.7996 24.574 39.7744 24.1006 39.6455C23.6272 39.5167 23.1871 39.2873 22.8104 38.9729C21.175 37.5813 21.1208 35.15 22.9146 33.6646H22.9167ZM32.8396 32.1021C33.0271 31.7521 37.0104 25.475 37.1312 25.1229C41.4146 28.9 43.4417 34.2521 43.1687 39.7604H35.2125C35.3646 36.8646 34.6083 34.1813 32.8396 32.1021ZM14.7583 39.7729H6.82917C6.08542 25.1438 21.7208 15.325 34.725 23.2729L27.5146 28.7271C20.6396 27.1396 14.2562 32.2896 14.7583 39.7729Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1359_2114">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default pageSpeedInsightLogo;
